import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConsultaCepRequest, ConsultaCepResponse } from 'src/app/@shared/models/consulta-cep.model';

@Injectable({
  providedIn: 'root'
})
export class ConsultaCepService {
  private httpClient: HttpClient;

  constructor(
    handler: HttpBackend,
    private http: HttpClient
  ) {
    this.httpClient = new HttpClient(handler);
  }

  consultaCEP(cep: ConsultaCepRequest): Observable<ConsultaCepResponse> {
    return this.httpClient.get<ConsultaCepResponse>(
      `https://viacep.com.br/ws/${cep}/json`
    )
  }
}
